import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Language } from '@/contexts/LanguageContext';

interface TranslationProgress {
  status: 'idle' | 'running' | 'completed' | 'failed';
  progress?: number;
  total?: number;
}

export const useTranslationProgress = (language: Language) => {
  const [progress, setProgress] = useState<TranslationProgress>({ status: 'idle' });

  useEffect(() => {
    // Translations are now manual only - keep state idle regardless of UI language
    setProgress({ status: 'idle' });
  }, [language]);

  return progress;
};
